export default "__VITE_ASSET__CWc7TX23__"